import { createUseCase } from '~core/usecase/createUseCase';
import { searchInventorys, searchProducts } from '~graphql/queries';
import { fetchedInventories, recievedInventories } from '~redux/inventory';
import {
  Inventory,
  Product,
  SearchInventorysQuery,
  SearchInventorysQueryVariables,
  SearchProductsQuery,
  SearchProductsQueryVariables,
} from '~types/api';
import { executeQuery } from '~utils/graphql';

export const fetchInventories = createUseCase(
  'inventory/fetchInventories',
  async (productIds: string[], { dispatch }) => {
    dispatch(fetchedInventories());

    const res = await executeQuery<
      SearchInventorysQuery,
      SearchInventorysQueryVariables
    >(searchInventorys, {
      filter: {
        or: productIds.map((productId) => ({ product_id: { eq: productId } })),
      },
      limit: 1000,
    });

    const inventories = (res.data?.searchInventorys?.items ?? []).filter(
      (item) =>
        item?.product?.product_public_status !== '非公開' &&
        item?.productType?.published !== false &&
        item?.product?.suspended !== true &&
        item?.productType?.suspended !== true
    ) as Omit<Inventory, '__typename'>[];
    const refetchProductIds = productIds.filter(
      (productId) =>
        !inventories.some((inventory) => inventory.product_id === productId)
    );

    //在庫情報未登録の商品を取得
    if (refetchProductIds.length) {
      const res2 = await executeQuery<
        SearchProductsQuery,
        SearchProductsQueryVariables
      >(searchProducts, {
        filter: {
          or: refetchProductIds.map((productId) => ({ id: { eq: productId } })),
        },
        limit: 1000,
      });
      const products = (res2.data?.searchProducts?.items ?? []) as Product[];
      inventories.push(
        ...products.flatMap((product) =>
          (product.producttype?.items ?? [null])
            .filter(
              (item) =>
                product?.product_public_status !== '非公開' &&
                !product?.suspended &&
                !item?.suspended &&
                item?.published !== false
            )
            .map((type) => ({
              id: type?.id ?? product?.id,
              product_id: product?.id,
              product_type_id: type?.id,
              brand_id: product?.product_brand_id,
              sku: type?.sku ?? product?.sku ?? type?.id ?? product?.id,
              product: product,
              productType: type ?? undefined,
              inventory: type?.out_of_stock || product?.out_of_stock ? 0 : null,
            }))
        )
      );
    }

    dispatch(recievedInventories(inventories));
  }
);
